module.exports = "/fonts/PT Root UI_Bold.woff?3785e0f7a4488fab86cc4a886ca9a3f1";